import * as React from 'react'

export function StaticInputMock({label, text}: { label: string, text: JSX.Element | string }) {
    return (
        <div>
            <div className="label">
                {label}
            </div>
            <div>
                {text}
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/View/StaticInputMock.tsx